import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddDictionaryItem } from "./modal"
import { EditDictionaryItem } from "./editModal"
import { Footer } from "../../../layout/footer"
import { options } from "../../../api";
import { Loading } from "../../constant";
import { dictionaryCRUD } from "../../../actions/dictionary"
import { UploadDictionaryItem } from "./upload"

export const DictionaryItemContent = () => {

  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0)
  const [value, setValue] = useState('')
  const [index, setIndex] = useState(0)
  const [deleteId, setDeleteId] = useState(null)
  const [editId, setEditId] = useState(null)
  
  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadDictionaryItem(postsPerPage, nextPage, value).then((resp) => {
        setCount(resp.data.count)
        setData(resp.data.results)
        setPageCount(Math.ceil(resp.data.count / postsPerPage))
      }).finally(() => {})
    }, 2000)

  }, [page, postsPerPage, value, index])

  const handleChangePage = (event) => {
    setData([])
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = selectedOption => {
    setData([])
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0)
  };

  const handleSearch = (event) => {
    setData([])
    setValue(event.target.value)
  }

  const handleDelete = () => {
    if (deleteId) {
      dictionaryCRUD.deleteDictionaryItem(deleteId)
        .then(() => {
          toast.success("Dictionary item deleted successfully!", { position: "top-right" });
          setIndex(index + 1); // Refresh the data
          setDeleteId(null);
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.error || "Failed to delete dictionary item";
          toast.error(errorMessage, { position: "top-right" });
          setDeleteId(null);
        });
    }
  }

  return (

    <>
      <ToastContainer />
      <AddDictionaryItem setIndex={setIndex} index={index}/>
      <EditDictionaryItem dataId={editId} setIndex={setIndex} index={index}/>
      <UploadDictionaryItem setIndex={setIndex} index={index}/>

      {/* Delete Confirmation Modal */}
      <div className="modal fade" id="deleteItemModal" tabIndex="-1" aria-labelledby="deleteItemModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteItemModalLabel">Confirm Delete</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this dictionary item?</p>
              <p className="text-danger"><small>This action cannot be undone.</small></p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={handleDelete}>Delete</button>
            </div>
          </div>
        </div>
      </div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">

            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Dictionary Item</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><Link to={'/dictionary'}>Dictionary</Link></li>
                      <li className="breadcrumb-item active">Item</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="d-flex justify-content-sm-start">
                            <div className="search-box ms-2">
                                <input type="text" className="form-control search" value={value} onChange={handleSearch} placeholder="Search..."/>
                                <i className="ri-search-line search-icon"></i>
                            </div>
                        </div>
                      </div>
                      <div className="col-md-6"></div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          <div className="col-auto">
                            <Link className="btn btn-soft-primary" data-bs-toggle="modal" data-bs-target=".addModal">
                              <i className="bi bi-plus-circle bi-lg"></i> &nbsp; New Item
                            </Link>
                          </div>
                          <div className="col-auto">
                            <Link to={'#'} className="btn btn-soft-info" data-bs-toggle="modal" data-bs-target=".uploadDictionaryItemModal">
                              <i className="bi bi-upload bi-lg"></i> &nbsp; Upload CSV
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table id="scroll-vertical" className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th data-ordering="true">SR No.</th>
                          <th data-ordering="true">Code</th>
                          <th data-ordering="true">English Name</th>
                          <th data-ordering="true">Swahili Name</th>
                          <th className="d-flex justify-content-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          data?.map((dt, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{dt.dictionary_item_code ? dt.dictionary_item_code : 'N/A'}</td>
                              <td>{dt.dictionary_item_name_en ? dt.dictionary_item_name_en : 'N/A'}</td>
                              <td>{dt.dictionary_item_name_sw ? dt.dictionary_item_name_sw : 'N/A'}</td>
                              <td className="d-flex justify-content-center">
                                <div className="hstack gap-3 fs-15">
                                  <button onClick={() => setEditId(dt.id)} data-bs-toggle="modal" data-bs-target=".editItemModal" className="btn btn-sm btn-soft-warning">
                                    <i className="bi bi-pencil-square"></i>
                                  </button>
                                  <button onClick={() => setDeleteId(dt.id)} data-bs-toggle="modal" data-bs-target="#deleteItemModal" className="btn btn-sm btn-soft-danger">
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    <div className="row">
                      {!data.length && <Loading/>}
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <p><span>Showing </span><span>{data.length}</span> of <span>{count}</span> entries</p>
                      </div>
                      <div className="col-md-5">

                      </div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select options={options} defaultValue={options[1]} onChange={handleChange} />
                          </div>
                          <div className="col-auto paginate" >
                            <ReactPaginate
                              previousLabel={<i className="las la-angle-double-left la-lg"></i>}
                              nextLabel={<i className="las la-angle-double-right la-lg"></i>}
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <Footer />
      </div>
    </>

  )

}